import {FieldName} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FieldRef} from '@mintdata/mint-kit/impl/frames/FieldRef';
import {FrameSelectionParseState} from '@mintdata/mint-kit/impl/frames/FrameSelectorTypes';
import bind from 'bind-decorator';
import * as OhmJs from 'ohm-js';

export type OhmNode = OhmJs.Node;

export class FrameEvalOperation
{
    private _state:FrameSelectionParseState;

    constructor()
    {
        for( const methodPtr in this )
        {
            if( methodPtr === 'resetState' ||
                methodPtr === 'getState' )
                continue;
            else
                Object.defineProperty(
                    this,
                    methodPtr,
                    {
                        enumerable: true,
                        configurable: false,
                        writable: false,
                        value: this[methodPtr]
                    }
                );
        }
    }

    resetState(availableFieldNames:FieldName[])
    {
        this._state = new FrameSelectionParseState();
        this._state.availableFieldRefs = availableFieldNames.map((fn:FieldName) =>
        {
            return new FieldRef(true, fn, null);
        });
    }

    getState():FrameSelectionParseState
    {
        return this._state;
    }

    @bind
    FrameSelector(arg0:OhmNode, arg1:OhmNode, arg2:OhmNode):void
    {
        arg1.eval();
        arg2.eval();
    }

    @bind
    AllColumnsSelector(arg0:OhmNode):void
    {
        this._state.fieldRefs = this._state.availableFieldRefs;
    }

    @bind
    ColumnSelectors(arg0:OhmNode, arg1:OhmNode):void
    {
        arg0.eval();
    }

    @bind
    RowIndexExpr(arg0:OhmNode, arg1:OhmNode, arg2:OhmNode):void
    {
        this._state.rowIndexExpr = arg1.sourceString;
    }

    @bind
    RowRangeExpr(arg0:OhmNode, arg1:OhmNode, arg2:OhmNode, arg3:OhmNode, arg4:OhmNode):void
    {
        this._state.rowRangeFromExpr = arg1.sourceString;
        this._state.rowRangeToExpr = arg3.sourceString;
    }

    @bind
    RowFilterExpr(arg0:OhmNode, arg1:OhmNode, arg2:OhmNode):void
    {
        this._state.rowFilterExpr = arg1.sourceString;
    }

    @bind
    ColumnName(arg0:OhmNode):void
    {
        const simpleFieldName = arg0.sourceString as FieldName;
        const fieldRef = new FieldRef(true, simpleFieldName, null);

        this._state.fieldRefs.push(fieldRef);
    }

    @bind
    NestedColumnName(arg0:OhmNode, arg1:any, arg2:any):void
    {
        const nestedPath = `${arg0.sourceString}${arg1.sourceString}`;
        const pathParts = nestedPath.split('.');
        const fieldRef = new FieldRef(false, null, pathParts);

        this._state.fieldRefs.push(fieldRef);
    }

    _terminal():void
    {
        // do nothing
    }
}
